import {NgModule} from '@angular/core';

import {HowToUnregisterComponent} from './how-to-unregister.component';
import { HowToUnregisterRoutingModule } from './how-to-unregister-routing.module';

@NgModule({
  declarations: [
    HowToUnregisterComponent,
  ],
  imports: [
    HowToUnregisterRoutingModule,
  ],
  providers: [],
  exports: [
    HowToUnregisterComponent,
  ],
})
export class HowToUnregisterModule {}
